import * as React from "react";
import {ProductsEnum} from "@falcon/services";

interface IProps {
    product: string,
}

export class DirectDebitInformationModal extends React.Component<IProps> {


    public render() {
        const faqUrl = this.props.product === ProductsEnum.HOME
            ? 'https://www.allianz.co.uk/insurance/home-insurance/faqs.html'
            : 'https://www.allianz.co.uk/insurance/car-insurance/faqs.html'
        return (
            <React.Fragment>
                <div className="inner-content mb-3 p-0">
                    <p>
                    <span className="font-weight-bold">
                        Please note that changes to your Direct Debit details can take up to 10 working days to take effect. </span>
                        That means if your next instalment date falls in this window, there's a small chance we'll miss
                        it.
                        If this happens you will have to pay the instalment by card.</p>
                    <p>
                        You must pay from your own current account (not a savings or business account).
                        Your payments will be collected under <span
                        className="font-weight-bold">Allianz Insurance</span> name.
                    </p>
                    <p>
                        Need help? <a className="d-inline font-weight-bold text-decoration-underline" target="_blank"
                                      href={faqUrl}>Our FAQs</a> have the answers for Direct Debit queries.
                    </p>
                </div>
            </React.Fragment>

        );
    }

}



// WEBPACK FOOTER //
// ./src/components/directDebit/DirectDebitInformationModal.tsx